/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type AlertSeverity = typeof AlertSeverity[keyof typeof AlertSeverity];


export const AlertSeverity = {
  Error: 'Error',
  Warning: 'Warning',
  Info: 'Info',
  Neutral: 'Neutral',
} as const;
